(function mdvSearchApiV2Module(root, factory) {
  'use strict';

  var runtimeVersion = 'mdv-search-api-v2-regional-20260807-1';
  var existing = root && root.MDVSearchApiV2;
  if (existing && existing.runtimeVersion === runtimeVersion) {
    if (typeof module === 'object' && module.exports) module.exports = existing;
    return;
  }

  var exported = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = exported;
  else if (root) root.MDVSearchApiV2 = exported;
}(typeof globalThis !== 'undefined' ? globalThis : this, function mdvSearchApiV2Factory(root) {
  'use strict';

  var API_PATH = '/v2';
  var CLIENT_CACHE_PREFIX = 'mdv-search-api-v2:lkg:';
  var DEFAULT_TIMEOUT_MS = 6000;
  var DEFAULT_DEBOUNCE_MS = 180;
  var DEFAULT_LAST_GOOD_TTL_MS = 5 * 60 * 1000;
  var MAX_QUERY_LENGTH = 100;
  var STORE_IDS = Object.freeze(['uk', 'us', 'eu', 'au', 'ca', 'me']);
  var NATIVE_FALLBACK_HTTP_CODES = new Set(['INVALID_MARKET', 'PRICE_CONTEXT_UNAVAILABLE']);
  // Currency is an assertion about Shopify's active buyer context. It is never
  // permission to perform client-side FX or switch an origin-bound catalogue.
  // Glopal proxies the EU and Middle East source stores onto these public
  // domains. The map pins each hostname to one API country so a page-global
  // value cannot redirect search into another store or market context.
  var GLOPAL_MARKET_HOSTS = Object.freeze({
    eu: Object.freeze({
      'at.manieredevoir.com': Object.freeze({ country: 'AT', locale: 'de-DE' }),
      'be.manieredevoir.com': Object.freeze({ country: 'BE', locale: 'fr-FR' }),
      'ch.manieredevoir.com': Object.freeze({ country: 'CH', locale: 'fr-FR' }),
      'de.manieredevoir.com': Object.freeze({ country: 'DE', locale: 'de-DE', locales: ['de-DE', 'en-US'] }),
      'dk.manieredevoir.com': Object.freeze({ country: 'DK', locale: 'da-DK' }),
      'es.manieredevoir.com': Object.freeze({ country: 'ES', locale: 'es-ES' }),
      'fi.manieredevoir.com': Object.freeze({ country: 'FI', locale: 'fi-FI' }),
      'fr.manieredevoir.com': Object.freeze({ country: 'FR', locale: 'fr-FR' }),
      'gr.manieredevoir.com': Object.freeze({ country: 'GR', locale: 'el-GR' }),
      'it.manieredevoir.com': Object.freeze({ country: 'IT', locale: 'it-IT' }),
      'lu.manieredevoir.com': Object.freeze({ country: 'LU', locale: 'fr-FR' }),
      'nl.manieredevoir.com': Object.freeze({ country: 'NL', locale: 'nl-NL' }),
      'no.manieredevoir.com': Object.freeze({ country: 'NO', locale: 'no-NO' }),
      'pl.manieredevoir.com': Object.freeze({ country: 'PL', locale: 'pl-PL' }),
      'pt.manieredevoir.com': Object.freeze({ country: 'PT', locale: 'pt-PT' }),
      'ro.manieredevoir.com': Object.freeze({ country: 'RO', locale: 'ro-RO' }),
      'se.manieredevoir.com': Object.freeze({ country: 'SE', locale: 'sv-SE' }),
    }),
    me: Object.freeze({
      'ae.manieredevoir.com': Object.freeze({ country: 'AE', locale: 'en-US', locales: ['en-AE', 'ar-AE', 'en-US'] }),
      'kw.manieredevoir.com': Object.freeze({ country: 'KW', locale: 'en-US' }),
      'qa.manieredevoir.com': Object.freeze({ country: 'QA', locale: 'en-US' }),
      'sa.manieredevoir.com': Object.freeze({ country: 'SA', locale: 'en-US' }),
    }),
  });
  var GENERIC_PROXY_HOSTS = Object.freeze({
    eu: 'eu.manieredevoir.com',
    me: 'me.manieredevoir.com',
  });
  var FACET_ORDER = Object.freeze([
    'gender',
    'category',
    'size',
    'colour',
    'fit',
    'material',
    'price',
    'availability',
    'sale',
  ]);
  var FACET_SET = new Set(FACET_ORDER);
  var PRICING_MODES = Object.freeze(['exact', 'price-free']);

  function SearchApiError(message, options) {
    options = options || {};
    Error.call(this, message);
    this.name = options.name || 'SearchApiError';
    this.message = message;
    this.code = options.code || 'SEARCH_API_ERROR';
    this.status = options.status == null ? null : Number(options.status);
    this.endpoint = options.endpoint || '';
    this.requestId = options.requestId || '';
    this.transient = options.transient === true;
    this.fallbackRecommended = options.fallbackRecommended !== false;
    if (options.details !== undefined) this.details = options.details;
    if (options.cause !== undefined) this.cause = options.cause;
    if (Error.captureStackTrace) Error.captureStackTrace(this, SearchApiError);
  }
  SearchApiError.prototype = Object.create(Error.prototype);
  SearchApiError.prototype.constructor = SearchApiError;

  function errorSubclass(name, defaultCode) {
    function TypedSearchApiError(message, options) {
      options = Object.assign({}, options || {}, { name: name, code: (options && options.code) || defaultCode });
      SearchApiError.call(this, message, options);
      if (Error.captureStackTrace) Error.captureStackTrace(this, TypedSearchApiError);
    }
    TypedSearchApiError.prototype = Object.create(SearchApiError.prototype);
    TypedSearchApiError.prototype.constructor = TypedSearchApiError;
    return TypedSearchApiError;
  }

  var SearchApiConfigurationError = errorSubclass('SearchApiConfigurationError', 'CONFIGURATION_ERROR');
  var SearchApiTimeoutError = errorSubclass('SearchApiTimeoutError', 'TIMEOUT');
  var SearchApiNetworkError = errorSubclass('SearchApiNetworkError', 'NETWORK_ERROR');
  var SearchApiHttpError = errorSubclass('SearchApiHttpError', 'HTTP_ERROR');
  var SearchApiResponseError = errorSubclass('SearchApiResponseError', 'INVALID_RESPONSE');
  var SearchApiAbortedError = errorSubclass('SearchApiAbortedError', 'ABORTED');
  var SearchApiUnsupportedPriceContextError = errorSubclass('SearchApiUnsupportedPriceContextError', 'PRICE_CONTEXT_UNAVAILABLE');

  function shouldUseNativeFallback(error) {
    if (!(error instanceof SearchApiError) || error.fallbackRecommended !== true) return false;
    if (error instanceof SearchApiAbortedError) return false;
    if (error instanceof SearchApiHttpError) {
      return transientHttpStatus(error.status) || NATIVE_FALLBACK_HTTP_CODES.has(error.code);
    }
    return error instanceof SearchApiTimeoutError
      || error instanceof SearchApiNetworkError
      || error instanceof SearchApiResponseError
      || error instanceof SearchApiUnsupportedPriceContextError;
  }

  function assertFreshResponse(response, payload, endpoint) {
    var staleHeader = response && response.headers && typeof response.headers.get === 'function'
      ? nonEmptyString(response.headers.get('x-mdv-index-stale'))
      : '';
    if (payload && payload.meta && payload.meta.stale === true || staleHeader === '1') {
      throw new SearchApiResponseError('The search service returned an expired market index.', {
        code: 'INDEX_STALE',
        endpoint: endpoint,
        requestId: responseRequestId(response, payload),
        transient: true,
      });
    }
  }

  function nonEmptyString(value) {
    return String(value == null ? '' : value).normalize('NFKC').trim();
  }

  function canonicalLocale(value) {
    var raw = nonEmptyString(value).replace(/_/g, '-');
    if (!/^[a-z]{2,3}(?:-[a-z0-9]{2,8})+$/i.test(raw)) return '';
    return raw.split('-').map(function formatLocalePart(part, index) {
      if (index === 0) return part.toLowerCase();
      if (part.length === 2 || /^\d{3}$/.test(part)) return part.toUpperCase();
      if (part.length === 4) return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
      return part.toLowerCase();
    }).join('-');
  }

  function canonicalCurrency(value) {
    var currency = nonEmptyString(value).toUpperCase();
    return /^[A-Z]{3}$/.test(currency) ? currency : '';
  }

  function normalizeApiBaseUrl(value) {
    var raw = nonEmptyString(value);
    var url;
    if (!raw) throw new SearchApiConfigurationError('The search API URL is required.');
    try {
      url = new URL(raw);
    } catch (error) {
      throw new SearchApiConfigurationError('The search API URL must be an absolute URL.', { cause: error });
    }
    var localDevelopment = /^(?:localhost|127\.0\.0\.1|\[::1\])$/i.test(url.hostname);
    if (url.protocol !== 'https:' && !(localDevelopment && url.protocol === 'http:')) {
      throw new SearchApiConfigurationError('The search API URL must use HTTPS.');
    }
    if (url.username || url.password || url.search || url.hash) {
      throw new SearchApiConfigurationError('The search API URL cannot contain credentials, a query or a fragment.');
    }
    var pathname = url.pathname.replace(/\/+/g, '/').replace(/\/+$/, '');
    if (!pathname.endsWith(API_PATH)) pathname += API_PATH;
    url.pathname = pathname;
    return url.toString().replace(/\/$/, '');
  }

  function normalizeContext(input) {
    input = input || {};
    var store = nonEmptyString(input.store).toLowerCase();
    var country = nonEmptyString(input.country).toUpperCase();
    var locale = canonicalLocale(input.locale);
    var currency = canonicalCurrency(input.currency);
    if (STORE_IDS.indexOf(store) === -1) {
      throw new SearchApiConfigurationError('An explicit supported store ID is required.', { details: { supported: STORE_IDS.slice() } });
    }
    if (!/^[A-Z]{2}$/.test(country)) throw new SearchApiConfigurationError('An explicit ISO two-letter country is required.');
    if (!locale) throw new SearchApiConfigurationError('An explicit language-region locale is required.');
    if (!currency) throw new SearchApiConfigurationError('An explicit ISO three-letter buyer currency is required.');
    return Object.freeze({ store: store, country: country, locale: locale, currency: currency });
  }

  function normalizeShopDomain(value) {
    var domain = nonEmptyString(value).toLowerCase();
    if (!domain) return '';
    if (!/^[a-z0-9](?:[a-z0-9-]{0,59}[a-z0-9])?\.myshopify\.com$/.test(domain)) {
      throw new SearchApiConfigurationError('Shop domain must be an explicit myshopify.com hostname.');
    }
    return domain;
  }

  function readAttribute(element, name, datasetName) {
    if (!element) return '';
    if (typeof element.getAttribute === 'function') {
      var attributeValue = element.getAttribute(name);
      if (attributeValue != null && String(attributeValue).trim()) return attributeValue;
    }
    return element.dataset ? element.dataset[datasetName] : '';
  }

  function configurationFromElement(element) {
    if (!element) throw new SearchApiConfigurationError('A search root element is required.');
    return {
      apiBaseUrl: readAttribute(element, 'data-mdv-search-api-url', 'mdvSearchApiUrl'),
      store: readAttribute(element, 'data-mdv-search-store', 'mdvSearchStore'),
      country: readAttribute(element, 'data-mdv-search-country', 'mdvSearchCountry'),
      locale: readAttribute(element, 'data-mdv-search-locale', 'mdvSearchLocale'),
      currency: readAttribute(element, 'data-mdv-search-currency', 'mdvSearchCurrency'),
      shopDomain: readAttribute(element, 'data-mdv-search-shop-domain', 'mdvSearchShopDomain'),
    };
  }

  function assertRuntimeCurrency(configuration, windowLike) {
    var expected = canonicalCurrency(configuration && configuration.currency);
    if (!expected) return;
    var guarded = canonicalCurrency(windowLike && windowLike.__mdvMarketCurrencyGuardV2Installed
      && windowLike.__mdvMarketCurrencyGuardV2Installed.activeCurrency);
    var shopify = canonicalCurrency(windowLike && windowLike.Shopify
      && windowLike.Shopify.currency && windowLike.Shopify.currency.active);
    var active = guarded || shopify;
    if (!active || active === expected) return;
    throw new SearchApiUnsupportedPriceContextError('The displayed currency does not match Shopify\'s active buyer currency.', {
      transient: false,
      fallbackRecommended: true,
      details: {
        expectedCurrency: expected,
        observed: [{ source: guarded ? 'market-currency-guard' : 'shopify', currency: active }],
      },
    });
  }

  function currencyForRuntime(configuration) {
    // Liquid renders the buyer currency for this document. A mutable Shopify
    // runtime global can be stale while a market change is settling, so it may
    // validate this value but must never replace it.
    return canonicalCurrency(configuration && configuration.currency);
  }

  function localeForProxyTarget(target, expected) {
    var fallback = canonicalLocale(expected && expected.locale);
    var requested = canonicalLocale(target && target.languageTag);
    var candidates = (expected && expected.locales || [fallback]).map(canonicalLocale).filter(Boolean);
    if (!requested || !candidates.length) return fallback;
    var exact = candidates.find(function exactLocale(candidate) {
      return candidate.toLowerCase() === requested.toLowerCase();
    });
    if (exact) return exact;
    var language = requested.split('-')[0].toLowerCase();
    return candidates.find(function sameLanguage(candidate) {
      return candidate.split('-')[0].toLowerCase() === language;
    }) || fallback;
  }

  function configurationForRuntime(configuration, windowLike) {
    var store = nonEmptyString(configuration && configuration.store).toLowerCase();
    var marketHosts = GLOPAL_MARKET_HOSTS[store];
    var target = windowLike && windowLike.glopalSettings && windowLike.glopalSettings.target;
    var hostname = nonEmptyString(windowLike && windowLike.location && windowLike.location.hostname).toLowerCase();
    var targetDomain = nonEmptyString(target && target.domain).toLowerCase();
    var country = nonEmptyString(target && target.countryCode).toUpperCase();
    var expected = marketHosts && marketHosts[hostname];
    var activeCurrency = currencyForRuntime(configuration, windowLike);
    var hostOwner = Object.keys(GLOPAL_MARKET_HOSTS).find(function findStore(candidate) {
      return Boolean(GLOPAL_MARKET_HOSTS[candidate] && GLOPAL_MARKET_HOSTS[candidate][hostname]);
    });
    var genericHostOwner = Object.keys(GENERIC_PROXY_HOSTS).find(function findGenericStore(candidate) {
      return GENERIC_PROXY_HOSTS[candidate] === hostname;
    });

    if ((hostOwner && hostOwner !== store) || (genericHostOwner && genericHostOwner !== store)) {
      throw new SearchApiUnsupportedPriceContextError('The public proxy hostname does not belong to the configured source store.', {
        transient: false,
        fallbackRecommended: true,
        details: { hostname: hostname, configuredStore: store, expectedStore: hostOwner || genericHostOwner },
      });
    }
    if (target && targetDomain === hostname && country === 'ROW') {
      throw new SearchApiUnsupportedPriceContextError('Rest of World does not identify a Shopify buyer-country context.', {
        transient: false,
        fallbackRecommended: true,
        details: { hostname: hostname, country: country },
      });
    }

    // A dedicated public proxy hostname is an origin-bound market assertion and
    // remains authoritative when Glopal initialises after the search adapter.
    // If a target object is already present it must agree in full; partial or
    // contradictory proxy state is never allowed to redirect the request.
    if (expected) {
      if (target && (targetDomain !== hostname || country !== expected.country)) {
        throw new SearchApiUnsupportedPriceContextError('The proxy target does not match the public market hostname.', {
          transient: false,
          fallbackRecommended: true,
          details: {
            hostname: hostname,
            expectedCountry: expected.country,
            targetDomain: targetDomain || null,
            targetCountry: country || null,
          },
        });
      }
      var resolved = Object.assign({}, configuration, {
        country: expected.country,
        locale: localeForProxyTarget(target, expected),
        currency: activeCurrency,
      });
      assertRuntimeCurrency(resolved, windowLike);
      return resolved;
    }

    // Generic EU/ME entry points (eu.manieredevoir.com, me.manieredevoir.com)
    // can serve many buyer countries WHEN Glopal is actively proxying this
    // origin -- confirmed live: the per-country subdomains (de./fr./nl. etc.)
    // resolve through Glopal's own edge and inject `glopalSettings`
    // server-side, but the generic hosts resolve directly to Shopify,
    // bypassing Glopal entirely. So `glopalSettings`'s presence is a reliable
    // signal for whether Glopal is live on THIS page, not just this store.
    // When present, a target bound to the current hostname is required --
    // source-store Liquid defaults such as DE or AE are never accepted as the
    // buyer country in that case. When entirely absent, Glopal is not
    // proxying this origin at all, so fall back to the Liquid-computed
    // configuration -- the same authority the non-Glopal stores (uk/us/au/ca)
    // already use via the !expected branch below. This keeps the guard live
    // if Glopal is ever rolled out to the generic hosts in future, since
    // refreshBuyerContext() re-resolves this on every request.
    if (GENERIC_PROXY_HOSTS[store] === hostname) {
      if (windowLike && windowLike.glopalSettings) {
        // Both generic proxy origins are configured as their store's controlled
        // English locale in the Worker. Glopal language tags such as en-QA are
        // presentation hints, not Worker market keys.
        var targetLocale = 'en-US';
        if (!target || targetDomain !== hostname || !/^[A-Z]{2}$/.test(country)) {
          throw new SearchApiUnsupportedPriceContextError('The generic proxy hostname does not identify an exact buyer market.', {
            transient: false,
            fallbackRecommended: true,
            details: {
              hostname: hostname,
              store: store,
              targetDomain: targetDomain || null,
              targetCountry: country || null,
            },
          });
        }
        var genericResolved = Object.assign({}, configuration, {
          country: country,
          locale: targetLocale,
          currency: activeCurrency,
        });
        assertRuntimeCurrency(genericResolved, windowLike);
        return genericResolved;
      }
      var genericFallback = Object.assign({}, configuration || {}, { currency: activeCurrency });
      assertRuntimeCurrency(genericFallback, windowLike);
      return genericFallback;
    }

    if (!expected) {
      var unchanged = Object.assign({}, configuration || {}, { currency: activeCurrency });
      assertRuntimeCurrency(unchanged, windowLike);
      return unchanged;
    }
  }

  function values(value) {
    if (value == null) return [];
    if (Array.isArray(value)) return value;
    if (value instanceof Set) return Array.from(value);
    return [value];
  }

  function canonicalValues(value) {
    var output = [];
    values(value).forEach(function flatten(item) {
      String(item == null ? '' : item).split(',').forEach(function add(part) {
        var normalized = nonEmptyString(part).toLowerCase();
        if (normalized && output.indexOf(normalized) === -1) output.push(normalized);
      });
    });
    return output.sort(function compare(left, right) { return left.localeCompare(right, 'en', { numeric: true, sensitivity: 'base' }); });
  }

  function normalizeFilters(filters) {
    filters = filters || {};
    var output = {};
    FACET_ORDER.forEach(function eachFacet(facet) {
      var facetValues = canonicalValues(filters[facet]);
      if (facetValues.length) output[facet] = facetValues;
    });
    return output;
  }

  function appendContext(parameters, context) {
    parameters.set('store', context.store);
    parameters.set('country', context.country);
    parameters.set('locale', context.locale);
    parameters.set('currency', context.currency);
  }

  function appendFilters(parameters, filters) {
    var normalized = normalizeFilters(filters);
    FACET_ORDER.forEach(function eachFacet(facet) {
      (normalized[facet] || []).forEach(function eachValue(value) {
        parameters.append('filter.' + facet, value);
      });
    });
  }

  function contextMatches(meta, context) {
    if (!meta || typeof meta !== 'object') return false;
    return String(meta.store || '').toLowerCase() === context.store
      && String(meta.country || '').toUpperCase() === context.country
      && canonicalLocale(meta.locale) === context.locale
      && canonicalCurrency(meta.currency) === context.currency;
  }

  function pricingMode(meta, endpoint) {
    var mode = nonEmptyString(meta && meta.pricingMode).toLowerCase();
    if (PRICING_MODES.indexOf(mode) === -1) {
      throw new SearchApiResponseError('The search response did not declare a supported pricing mode.', {
        endpoint: endpoint,
        transient: true,
        details: { receivedPricingMode: mode || null, supportedPricingModes: PRICING_MODES.slice() },
      });
    }
    return mode;
  }

  function hasOwn(object, property) {
    return Boolean(object && typeof object === 'object' && Object.prototype.hasOwnProperty.call(object, property));
  }

  function assertPriceFreeResult(result, endpoint, resultIndex) {
    var pending = [{ value: result, path: 'results[' + resultIndex + ']' }];
    var visited = new Set();
    while (pending.length) {
      var entry = pending.pop();
      var value = entry.value;
      if (!value || typeof value !== 'object' || visited.has(value)) continue;
      visited.add(value);
      if (hasOwn(value, 'price') || hasOwn(value, 'compareAtPrice') || hasOwn(value, 'compare_at_price')
        || hasOwn(value, 'priceRange') || hasOwn(value, 'minPrice') || hasOwn(value, 'maxPrice')
        || hasOwn(value, 'saleBand')) {
        throw new SearchApiUnsupportedPriceContextError('The price-free search response leaked price or sale data.', {
          endpoint: endpoint,
          transient: true,
          fallbackRecommended: true,
          details: { path: entry.path },
        });
      }
      if (Array.isArray(value)) {
        value.forEach(function visitArrayItem(item, index) {
          pending.push({ value: item, path: entry.path + '[' + index + ']' });
        });
      } else {
        Object.keys(value).forEach(function visitProperty(key) {
          pending.push({ value: value[key], path: entry.path + '.' + key });
        });
      }
    }
  }

  function assertExactResult(result, context, endpoint, resultIndex) {
    if (!result || typeof result !== 'object' || Array.isArray(result)
      || !result.leadVariant || typeof result.leadVariant !== 'object' || Array.isArray(result.leadVariant)) {
      throw new SearchApiUnsupportedPriceContextError('The exact-price search response is missing its lead variant.', {
        endpoint: endpoint,
        transient: true,
        fallbackRecommended: true,
        details: { path: 'results[' + resultIndex + '].leadVariant', expectedCurrency: context.currency },
      });
    }
    var variants = [{ value: result.leadVariant, path: 'results[' + resultIndex + '].leadVariant' }];
    if (Array.isArray(result.variantOptions)) result.variantOptions.forEach(function variantOption(variant, variantIndex) {
      variants.push({ value: variant, path: 'results[' + resultIndex + '].variantOptions[' + variantIndex + ']' });
    });
    if (Array.isArray(result.variants)) result.variants.forEach(function variant(variantValue, variantIndex) {
      variants.push({ value: variantValue, path: 'results[' + resultIndex + '].variants[' + variantIndex + ']' });
    });
    if (hasOwn(result, 'price') || hasOwn(result, 'compareAtPrice')) {
      variants.push({ value: result, path: 'results[' + resultIndex + ']' });
    }
    variants.forEach(function validateVariant(entry) {
      var variant = entry.value;
      if (!variant || typeof variant !== 'object' || Array.isArray(variant)) {
        throw new SearchApiUnsupportedPriceContextError('The search response contained an invalid price context.', {
          endpoint: endpoint,
          transient: true,
          details: { path: entry.path, expectedCurrency: context.currency },
        });
      }
      validateMoney(variant.price, context.currency, endpoint, entry.path + '.price', false);
      validateMoney(variant.compareAtPrice, context.currency, endpoint, entry.path + '.compareAtPrice', true);
    });
  }

  function assertObject(payload, endpoint) {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
      throw new SearchApiResponseError('The search API returned an invalid JSON object.', { endpoint: endpoint, transient: true });
    }
  }

  function validateSearchPayload(payload, context, endpoint) {
    assertObject(payload, endpoint);
    if (!Array.isArray(payload.results) || typeof payload.total !== 'number' || !contextMatches(payload.meta, context)) {
      throw new SearchApiResponseError('The search response did not match the requested market contract.', { endpoint: endpoint, transient: true });
    }
    var mode = pricingMode(payload.meta, endpoint);
    if (mode === 'price-free') {
      if (hasOwn(payload.facets, 'price') || hasOwn(payload.facets, 'sale')
        || hasOwn(payload.facetDefinitions, 'price') || hasOwn(payload.facetDefinitions, 'sale')) {
        throw new SearchApiUnsupportedPriceContextError('The price-free search response leaked price-derived facets.', {
          endpoint: endpoint,
          transient: true,
          fallbackRecommended: true,
        });
      }
      payload.results.forEach(function validatePriceFreeResult(result, resultIndex) {
        if (!result || typeof result !== 'object' || Array.isArray(result)) {
          throw new SearchApiResponseError('The price-free search response contained an invalid result card.', {
            endpoint: endpoint,
            transient: true,
            details: { path: 'results[' + resultIndex + ']' },
          });
        }
        assertPriceFreeResult(result, endpoint, resultIndex);
      });
      return;
    }
    payload.results.forEach(function validateResult(result, resultIndex) {
      assertExactResult(result, context, endpoint, resultIndex);
    });
  }

  function validateMoney(money, expectedCurrency, endpoint, path, nullable) {
    if (money == null && nullable) return;
    var rawAmount = nonEmptyString(money && money.amount);
    var amount = Number(rawAmount);
    var currency = canonicalCurrency(money && money.currencyCode);
    if (!money || typeof money !== 'object' || Array.isArray(money)
      || !rawAmount || !Number.isFinite(amount) || amount < 0 || currency !== expectedCurrency) {
      throw new SearchApiUnsupportedPriceContextError('The search response contained money outside the active buyer currency.', {
        endpoint: endpoint,
        transient: true,
        fallbackRecommended: true,
        details: {
          path: path,
          expectedCurrency: expectedCurrency,
          receivedCurrency: currency || null,
        },
      });
    }
  }

  function validateSuggestPayload(payload, context, endpoint) {
    assertObject(payload, endpoint);
    if (!Array.isArray(payload.suggestions) || !Array.isArray(payload.collections) || !contextMatches(payload.meta, context)) {
      throw new SearchApiResponseError('The suggestion response did not match the requested market contract.', { endpoint: endpoint, transient: true });
    }
    pricingMode(payload.meta, endpoint);
  }

  function validateDiscoveryPayload(payload, context, endpoint) {
    assertObject(payload, endpoint);
    if (!Array.isArray(payload.trending) || !Array.isArray(payload.popularCollections) || !contextMatches(payload.meta, context)) {
      throw new SearchApiResponseError('The discovery response did not match the requested market contract.', { endpoint: endpoint, transient: true });
    }
    pricingMode(payload.meta, endpoint);
  }

  function validateEventPayload(payload, _context, endpoint) {
    assertObject(payload, endpoint);
    if (typeof payload.accepted !== 'number') {
      throw new SearchApiResponseError('The telemetry response did not match the shared contract.', { endpoint: endpoint, transient: true });
    }
  }

  function safeSessionStorage(candidate) {
    try {
      if (candidate && typeof candidate.getItem === 'function' && typeof candidate.setItem === 'function') return candidate;
    } catch (_) {
      // Storage access can be blocked by browser privacy settings.
    }
    return null;
  }

  function parseJson(text, endpoint) {
    try {
      return JSON.parse(text);
    } catch (error) {
      throw new SearchApiResponseError('The search API returned malformed JSON.', { endpoint: endpoint, cause: error, transient: true });
    }
  }

  function responseRequestId(response, payload) {
    return nonEmptyString(payload && payload.error && payload.error.requestId)
      || nonEmptyString(response && response.headers && response.headers.get && response.headers.get('cf-ray'));
  }

  function transientHttpStatus(status) {
    return status === 408 || status === 425 || status === 429 || status >= 500;
  }

  function abortRace(externalSignal, timeoutMs, endpoint) {
    if (typeof AbortController !== 'function') {
      throw new SearchApiConfigurationError('AbortController is required for the search client.');
    }
    var controller = new AbortController();
    var rejectAbort;
    var timer = null;
    var onExternalAbort = null;
    var abortPromise = new Promise(function registerAbort(_resolve, reject) { rejectAbort = reject; });
    if (externalSignal) {
      onExternalAbort = function externalAbort() {
        controller.abort();
        rejectAbort(new SearchApiAbortedError('The search request was cancelled.', {
          endpoint: endpoint,
          transient: false,
          fallbackRecommended: false,
        }));
      };
      if (externalSignal.aborted) onExternalAbort();
      else externalSignal.addEventListener('abort', onExternalAbort, { once: true });
    }
    timer = setTimeout(function requestTimeout() {
      controller.abort();
      rejectAbort(new SearchApiTimeoutError('The search service did not respond in time.', {
        endpoint: endpoint,
        transient: true,
      }));
    }, timeoutMs);
    return {
      signal: controller.signal,
      promise: abortPromise,
      cleanup: function cleanup() {
        clearTimeout(timer);
        if (externalSignal && onExternalAbort) externalSignal.removeEventListener('abort', onExternalAbort);
      },
    };
  }

  function assertActiveRequestContext(client, requestedContext) {
    var activeContext = normalizeContext(configurationForRuntime(client.runtimeConfiguration, client.windowLike));
    client.context = activeContext;
    if (!contextMatches(activeContext, requestedContext)) {
      throw new SearchApiUnsupportedPriceContextError('The active buyer context changed while search results were loading.', {
        transient: false,
        fallbackRecommended: true,
        details: {
          requested: requestedContext,
          active: activeContext,
        },
      });
    }
    return activeContext;
  }

  function SearchApiClient(configuration) {
    configuration = configuration || {};
    this.apiBaseUrl = normalizeApiBaseUrl(configuration.apiBaseUrl);
    this.windowLike = configuration.windowLike || root;
    this.runtimeConfiguration = Object.assign({}, configuration.runtimeConfiguration || configuration);
    delete this.runtimeConfiguration.windowLike;
    delete this.runtimeConfiguration.runtimeConfiguration;
    this.context = normalizeContext(configurationForRuntime(this.runtimeConfiguration, this.windowLike));
    this.shopDomain = normalizeShopDomain(configuration.shopDomain);
    this.fetchImpl = configuration.fetchImpl || (typeof fetch === 'function' ? fetch.bind(globalThis) : null);
    if (!this.fetchImpl) throw new SearchApiConfigurationError('A fetch implementation is required.');
    this.timeoutMs = Number.isFinite(Number(configuration.timeoutMs))
      ? Math.max(250, Number(configuration.timeoutMs))
      : DEFAULT_TIMEOUT_MS;
    this.debounceMs = Number.isFinite(Number(configuration.debounceMs))
      ? Math.max(0, Number(configuration.debounceMs))
      : DEFAULT_DEBOUNCE_MS;
    this.lastGoodTtlMs = Number.isFinite(Number(configuration.lastGoodTtlMs))
      ? Math.max(0, Number(configuration.lastGoodTtlMs))
      : DEFAULT_LAST_GOOD_TTL_MS;
    // Safari's "Block All Cookies" (and some blockers) make even `typeof
    // sessionStorage` throw, before safeSessionStorage() could catch it.
    this.sessionStorage = safeSessionStorage(configuration.sessionStorage
      || (function globalSessionStorage() {
        try { return typeof sessionStorage !== 'undefined' ? sessionStorage : null; }
        catch (_) { return null; }
      })());
    this.memoryCache = new Map();
    this.getTelemetryConsent = typeof configuration.getTelemetryConsent === 'function'
      ? configuration.getTelemetryConsent
      : function telemetryDisabledByDefault() { return false; };
    this.onTelemetryDecision = typeof configuration.onTelemetryDecision === 'function'
      ? configuration.onTelemetryDecision
      : null;
    this.onResponseMeta = typeof configuration.onResponseMeta === 'function'
      ? configuration.onResponseMeta
      : null;
    this.debounced = new Map();
  }

  SearchApiClient.prototype.refreshContext = function refreshContext() {
    this.context = normalizeContext(configurationForRuntime(this.runtimeConfiguration, this.windowLike));
    return this.context;
  };

  SearchApiClient.prototype.endpointUrl = function endpointUrl(endpoint, parameters) {
    var url = new URL(this.apiBaseUrl + endpoint);
    appendContext(url.searchParams, this.context);
    if (parameters) parameters(url.searchParams);
    return url;
  };

  SearchApiClient.prototype.cacheKey = function cacheKey(url) {
    return CLIENT_CACHE_PREFIX + encodeURIComponent([
      this.apiBaseUrl,
      this.context.store,
      this.context.country,
      this.context.locale,
      this.context.currency,
      this.shopDomain,
      url.pathname,
      url.search,
    ].join('|'));
  };

  SearchApiClient.prototype.writeLastGood = function writeLastGood(key, payload) {
    var entry = { writtenAt: Date.now(), payload: payload };
    this.memoryCache.set(key, entry);
    if (!this.sessionStorage) return;
    try {
      this.sessionStorage.setItem(key, JSON.stringify(entry));
    } catch (_) {
      // The in-memory entry still protects the active page session.
    }
  };

  SearchApiClient.prototype.readLastGood = function readLastGood(key) {
    var entry = this.memoryCache.get(key) || null;
    if (!entry && this.sessionStorage) {
      try {
        entry = JSON.parse(this.sessionStorage.getItem(key) || 'null');
      } catch (_) {
        entry = null;
      }
    }
    if (!entry || typeof entry.writtenAt !== 'number' || !entry.payload
      || Date.now() - entry.writtenAt > this.lastGoodTtlMs) {
      this.deleteLastGood(key);
      return null;
    }
    this.memoryCache.set(key, entry);
    return entry.payload;
  };

  SearchApiClient.prototype.deleteLastGood = function deleteLastGood(key) {
    this.memoryCache.delete(key);
    if (!this.sessionStorage || typeof this.sessionStorage.removeItem !== 'function') return;
    try { this.sessionStorage.removeItem(key); } catch (_) { /* no-op */ }
  };

  SearchApiClient.prototype.reportResponse = function reportResponse(metadata) {
    if (!this.onResponseMeta) return;
    try { this.onResponseMeta(metadata); } catch (_) { /* Observation must not break search. */ }
  };

  SearchApiClient.prototype.request = async function request(endpoint, requestOptions) {
    requestOptions = requestOptions || {};
    var requestContext = this.refreshContext();
    var url = this.endpointUrl(endpoint, requestOptions.parameters);
    var method = requestOptions.method || 'GET';
    var cacheKey = method === 'GET' ? this.cacheKey(url) : '';
    var timeoutMs = Number.isFinite(Number(requestOptions.timeoutMs))
      ? Math.max(250, Number(requestOptions.timeoutMs))
      : this.timeoutMs;
    var abort = abortRace(requestOptions.signal, timeoutMs, endpoint);
    var headers = { accept: 'application/json' };
    if (this.shopDomain) headers['x-mdv-shop-domain'] = this.shopDomain;
    var fetchOptions = {
      method: method,
      headers: headers,
      credentials: 'omit',
      referrerPolicy: 'no-referrer',
      signal: abort.signal,
    };
    if (requestOptions.body !== undefined) {
      headers['content-type'] = 'application/json';
      fetchOptions.body = JSON.stringify(requestOptions.body);
      fetchOptions.keepalive = requestOptions.keepalive === true;
    }

    try {
      var response = await Promise.race([this.fetchImpl(url.toString(), fetchOptions), abort.promise]);
      var text = await Promise.race([response.text(), abort.promise]);
      var payload = text ? parseJson(text, endpoint) : {};
      // A buyer-country, language or currency selector may change while the
      // request is in flight. Re-resolve the complete runtime tuple and never
      // accept the previous market response into visible state or cache merely
      // because both markets happen to use the same currency.
      assertActiveRequestContext(this, requestContext);
      if (!response.ok) {
        var apiError = payload && payload.error;
        throw new SearchApiHttpError(nonEmptyString(apiError && apiError.message) || ('The search API returned HTTP ' + response.status + '.'), {
          code: nonEmptyString(apiError && apiError.code) || 'HTTP_' + response.status,
          status: response.status,
          endpoint: endpoint,
          requestId: responseRequestId(response, payload),
          details: apiError && apiError.details,
          transient: transientHttpStatus(response.status),
        });
      }
      if (requestOptions.validate) requestOptions.validate(payload, requestContext, endpoint);
      assertFreshResponse(response, payload, endpoint);
      if (cacheKey) this.writeLastGood(cacheKey, payload);
      this.reportResponse({ source: 'network', stale: false, endpoint: endpoint, context: requestContext, meta: payload.meta || null });
      return payload;
    } catch (error) {
      var typed = error;
      if (!(typed instanceof SearchApiError)) {
        if (abort.signal.aborted) {
          typed = new SearchApiAbortedError('The search request was cancelled.', {
            endpoint: endpoint,
            cause: error,
            transient: false,
            fallbackRecommended: false,
          });
        } else {
          typed = new SearchApiNetworkError('The search service could not be reached.', {
            endpoint: endpoint,
            cause: error,
            transient: true,
          });
        }
      }
      if (cacheKey && typed.transient) {
        try {
          // A transport failure must not make an old market's last-known-good
          // response eligible after the buyer selector has changed.
          assertActiveRequestContext(this, requestContext);
        } catch (contextError) {
          typed = contextError instanceof SearchApiError
            ? contextError
            : new SearchApiUnsupportedPriceContextError('The active buyer context could not be verified for cached search results.', {
              transient: false,
              fallbackRecommended: true,
              cause: contextError,
            });
        }
      }
      if (cacheKey && typed.transient) {
        var cached = this.readLastGood(cacheKey);
        if (cached) {
          try {
            if (requestOptions.validate) requestOptions.validate(cached, requestContext, endpoint);
            this.reportResponse({ source: 'session-cache', stale: true, endpoint: endpoint, context: requestContext, meta: cached.meta || null, error: typed });
            return cached;
          } catch (_) {
            this.deleteLastGood(cacheKey);
          }
        }
      }
      throw typed;
    } finally {
      abort.cleanup();
    }
  };

  SearchApiClient.prototype.search = function search(input, options) {
    input = input || {};
    options = options || {};
    var query = nonEmptyString(input.query != null ? input.query : input.q);
    var scope = nonEmptyString(input.scope).toLowerCase();
    var collectionHandle = nonEmptyString(input.collectionHandle != null ? input.collectionHandle : input.collection_handle).toLowerCase();
    var sort = nonEmptyString(input.sort).toLowerCase();
    if (query.length > MAX_QUERY_LENGTH) {
      return Promise.reject(new SearchApiConfigurationError('Search queries cannot exceed ' + MAX_QUERY_LENGTH + ' characters.'));
    }
    if (scope && ['search', 'collection'].indexOf(scope) === -1) {
      return Promise.reject(new SearchApiConfigurationError('Search scope must be search or collection.'));
    }
    if (collectionHandle && scope !== 'collection') {
      return Promise.reject(new SearchApiConfigurationError('A collection handle requires collection scope.'));
    }
    return this.request('/search', {
      signal: options.signal,
      timeoutMs: options.timeoutMs,
      validate: validateSearchPayload,
      parameters: function searchParameters(parameters) {
        parameters.set('q', query);
        appendFilters(parameters, input.filters);
        if (input.limit != null) parameters.set('limit', String(input.limit));
        if (input.cursor != null && String(input.cursor) !== '') parameters.set('cursor', String(input.cursor));
        if (input.includeGender === false) parameters.set('includeGender', 'false');
        if (scope) parameters.set('scope', scope);
        if (collectionHandle) parameters.set('collection_handle', collectionHandle);
        if (sort) parameters.set('sort', sort);
      },
    });
  };

  // Retained as a semantic alias for collection controllers; request state is
  // handled directly and never by mutating the client endpoint method.
  SearchApiClient.prototype.searchWithScope = SearchApiClient.prototype.search;

  SearchApiClient.prototype.suggest = function suggest(input, options) {
    input = input || {};
    options = options || {};
    var query = nonEmptyString(input.query != null ? input.query : input.q);
    if (query.length > MAX_QUERY_LENGTH) {
      return Promise.reject(new SearchApiConfigurationError('Search queries cannot exceed ' + MAX_QUERY_LENGTH + ' characters.'));
    }
    return this.request('/suggest', {
      signal: options.signal,
      timeoutMs: options.timeoutMs,
      validate: validateSuggestPayload,
      parameters: function suggestParameters(parameters) {
        parameters.set('q', query);
        if (input.limit != null) parameters.set('limit', String(input.limit));
      },
    });
  };

  SearchApiClient.prototype.discovery = function discovery(options) {
    options = options || {};
    return this.request('/discovery', {
      signal: options.signal,
      timeoutMs: options.timeoutMs,
      validate: validateDiscoveryPayload,
    });
  };

  SearchApiClient.prototype.hasTelemetryConsent = async function hasTelemetryConsent(eventOrEvents) {
    try {
      return (await this.getTelemetryConsent({ context: this.context, events: eventOrEvents })) === true;
    } catch (_) {
      return false;
    }
  };

  SearchApiClient.prototype.reportTelemetryDecision = function reportTelemetryDecision(allowed, reason, events) {
    if (!this.onTelemetryDecision) return;
    try { this.onTelemetryDecision({ allowed: allowed, reason: reason, events: events, context: this.context }); } catch (_) { /* no-op */ }
  };

  SearchApiClient.prototype.sendEvent = async function sendEvent(event, options) {
    options = options || {};
    this.refreshContext();
    if (!(await this.hasTelemetryConsent([event]))) {
      this.reportTelemetryDecision(false, 'consent', [event]);
      return { accepted: 0, skipped: true, reason: 'consent' };
    }
    this.reportTelemetryDecision(true, 'consent', [event]);
    var body = Object.assign({}, event || {}, this.context);
    return this.request('/events', {
      method: 'POST',
      body: body,
      keepalive: options.keepalive !== false,
      signal: options.signal,
      timeoutMs: options.timeoutMs,
      validate: validateEventPayload,
    });
  };

  SearchApiClient.prototype.sendEvents = async function sendEvents(events, options) {
    options = options || {};
    this.refreshContext();
    var eventList = Array.isArray(events) ? events.slice() : [];
    if (!(await this.hasTelemetryConsent(eventList))) {
      this.reportTelemetryDecision(false, 'consent', eventList);
      return { accepted: 0, skipped: true, reason: 'consent' };
    }
    this.reportTelemetryDecision(true, 'consent', eventList);
    return this.request('/events/batch', {
      method: 'POST',
      body: { store: this.context.store, country: this.context.country, locale: this.context.locale, currency: this.context.currency, events: eventList },
      keepalive: options.keepalive !== false,
      signal: options.signal,
      timeoutMs: options.timeoutMs,
      validate: validateEventPayload,
    });
  };

  SearchApiClient.prototype.schedule = function schedule(kind, invoke, debounceMs) {
    var self = this;
    self.cancelDebounced(kind);
    return new Promise(function scheduledPromise(resolve, reject) {
      var controller = new AbortController();
      var slot = {
        controller: controller,
        reject: reject,
        started: false,
        timer: setTimeout(function executeScheduled() {
          slot.started = true;
          Promise.resolve().then(function invokeScheduled() { return invoke(controller.signal); })
            .then(resolve, reject)
            .finally(function clearSlot() {
              if (self.debounced.get(kind) === slot) self.debounced.delete(kind);
            });
        }, debounceMs),
      };
      self.debounced.set(kind, slot);
    });
  };

  SearchApiClient.prototype.debouncedSearch = function debouncedSearch(input, options) {
    options = options || {};
    var self = this;
    var delay = Number.isFinite(Number(options.debounceMs)) ? Math.max(0, Number(options.debounceMs)) : this.debounceMs;
    return this.schedule('search', function invokeSearch(signal) {
      return self.search(input, { signal: signal, timeoutMs: options.timeoutMs });
    }, delay);
  };

  SearchApiClient.prototype.debouncedSuggest = function debouncedSuggest(input, options) {
    options = options || {};
    var self = this;
    var delay = Number.isFinite(Number(options.debounceMs)) ? Math.max(0, Number(options.debounceMs)) : this.debounceMs;
    return this.schedule('suggest', function invokeSuggest(signal) {
      return self.suggest(input, { signal: signal, timeoutMs: options.timeoutMs });
    }, delay);
  };

  SearchApiClient.prototype.cancelDebounced = function cancelDebounced(kind) {
    var slot = this.debounced.get(kind);
    if (!slot) return;
    clearTimeout(slot.timer);
    slot.controller.abort();
    if (!slot.started) {
      slot.reject(new SearchApiAbortedError('The queued search request was superseded.', {
        endpoint: kind,
        transient: false,
        fallbackRecommended: false,
      }));
    }
    this.debounced.delete(kind);
  };

  SearchApiClient.prototype.cancelAll = function cancelAll() {
    var self = this;
    Array.from(this.debounced.keys()).forEach(function cancel(kind) { self.cancelDebounced(kind); });
  };

  function toUrl(value, baseUrl) {
    if (value instanceof URL) return new URL(value.toString());
    try {
      return new URL(String(value), baseUrl || (typeof location !== 'undefined' ? location.href : undefined));
    } catch (error) {
      throw new SearchApiConfigurationError('An absolute URL or base URL is required for search history helpers.', { cause: error });
    }
  }

  function isOwnedFilterParameter(name) {
    var dotted = name.match(/^filter\.([a-z_]+)$/i);
    var bracketed = name.match(/^filter\[([a-z_]+)\]$/i);
    var facet = dotted ? dotted[1] : bracketed ? bracketed[1] : name;
    return FACET_SET.has(String(facet).toLowerCase());
  }

  function readSearchState(urlValue, options) {
    options = options || {};
    var url = toUrl(urlValue, options.baseUrl);
    var parameters = url.searchParams;
    var filters = {};
    FACET_ORDER.forEach(function eachFacet(facet) {
      filters[facet] = canonicalValues([].concat(
        parameters.getAll('filter.' + facet),
        parameters.getAll('filter[' + facet + ']'),
        parameters.getAll(facet)
      ));
    });
    return {
      query: nonEmptyString(parameters.get('q')),
      sort: nonEmptyString(parameters.get('sort')) || 'relevance',
      cursor: nonEmptyString(parameters.get('cursor')) || null,
      filters: filters,
    };
  }

  function buildSearchStateUrl(currentUrl, state, options) {
    options = options || {};
    state = state || {};
    var url = toUrl(currentUrl, options.baseUrl);
    var parameters = url.searchParams;
    Array.from(parameters.keys()).forEach(function deleteOwned(name) {
      if (name === 'q' || name === 'sort' || name === 'cursor' || isOwnedFilterParameter(name)) parameters.delete(name);
    });
    var query = nonEmptyString(state.query != null ? state.query : state.q);
    if (query) parameters.set('q', query);
    var normalizedFilters = normalizeFilters(state.filters);
    FACET_ORDER.forEach(function eachFacet(facet) {
      (normalizedFilters[facet] || []).forEach(function eachValue(value) {
        parameters.append('filter.' + facet, value);
      });
    });
    var sort = nonEmptyString(state.sort);
    if (sort && sort !== 'relevance') parameters.set('sort', sort);
    if (state.cursor != null && nonEmptyString(state.cursor)) parameters.set('cursor', nonEmptyString(state.cursor));
    return url.toString();
  }

  function createHistoryAdapter(windowLike, onRestore, options) {
    options = options || {};
    if (!windowLike || !windowLike.location || !windowLike.history
      || typeof windowLike.addEventListener !== 'function' || typeof windowLike.removeEventListener !== 'function') {
      throw new SearchApiConfigurationError('A browser-like window is required for search history integration.');
    }
    if (typeof onRestore !== 'function') throw new SearchApiConfigurationError('A popstate restore callback is required.');
    var listening = false;
    var editing = Boolean(windowLike.history.state && windowLike.history.state.mdvSearchV2Draft === true);
    function read() { return readSearchState(windowLike.location.href); }
    function write(state, mode, draft) {
      var next = buildSearchStateUrl(windowLike.location.href, state);
      var historyState = Object.assign({}, windowLike.history.state || {}, {
        mdvSearchV2: true,
        mdvSearchV2Draft: draft === true,
      });
      windowLike.history[mode + 'State'](historyState, '', next);
      return next;
    }
    function popstate(event) {
      editing = Boolean(event && event.state && event.state.mdvSearchV2Draft === true);
      onRestore(read(), event);
    }
    return {
      read: read,
      edit: function edit(state) {
        var mode = editing ? 'replace' : 'push';
        editing = true;
        return write(state, mode, true);
      },
      commit: function commit(state) {
        var mode = editing ? 'replace' : 'push';
        editing = false;
        return write(state, mode, false);
      },
      replace: function replace(state) { return write(state, 'replace', editing); },
      push: function push(state) {
        editing = false;
        return write(state, 'push', false);
      },
      start: function start() {
        if (!listening) windowLike.addEventListener('popstate', popstate);
        listening = true;
      },
      stop: function stop() {
        if (listening) windowLike.removeEventListener('popstate', popstate);
        listening = false;
      },
    };
  }

  function createClient(configuration) { return new SearchApiClient(configuration); }

  function createClientFromElement(element, options) {
    var clientOptions = Object.assign({}, options || {});
    var windowLike = clientOptions.windowLike || root;
    delete clientOptions.windowLike;
    var rawConfiguration = configurationFromElement(element);
    var configuration = configurationForRuntime(rawConfiguration, windowLike);
    return new SearchApiClient(Object.assign({}, clientOptions, configuration, {
      windowLike: windowLike,
      runtimeConfiguration: rawConfiguration,
    }));
  }

  return Object.freeze({
    runtimeVersion: 'mdv-search-api-v2-regional-20260807-1',
    API_PATH: API_PATH,
    FACET_ORDER: FACET_ORDER,
    PRICING_MODES: PRICING_MODES,
    STORE_IDS: STORE_IDS,
    SearchApiClient: SearchApiClient,
    SearchApiError: SearchApiError,
    SearchApiConfigurationError: SearchApiConfigurationError,
    SearchApiTimeoutError: SearchApiTimeoutError,
    SearchApiNetworkError: SearchApiNetworkError,
    SearchApiHttpError: SearchApiHttpError,
    SearchApiResponseError: SearchApiResponseError,
    SearchApiAbortedError: SearchApiAbortedError,
    SearchApiUnsupportedPriceContextError: SearchApiUnsupportedPriceContextError,
    buildSearchStateUrl: buildSearchStateUrl,
    configurationFromElement: configurationFromElement,
    configurationForRuntime: configurationForRuntime,
    createClient: createClient,
    createClientFromElement: createClientFromElement,
    createHistoryAdapter: createHistoryAdapter,
    normalizeFilters: normalizeFilters,
    readSearchState: readSearchState,
    shouldUseNativeFallback: shouldUseNativeFallback,
  });
}));
